import { useState, useEffect, Suspense, useRef } from 'react'
import { Await, defer, Link, useSearchParams, useNavigate, useLoaderData, useActionData, json, Form, Navigate, useParams } from 'react-router-dom'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/PassageNew.module.scss'
import LoadingSpinner from './components/LoadingSpinner'
import { ideaUpdate, getIdeaEdit } from '../util/p_api'
import { ideaCategory, ideaCategory2, submitIdea, getEducationlevel } from '../util/api'
import * as L from 'leaflet/dist/leaflet'
import Logo from './../logo.svg'
import MarkerIcon from './../images/marker-icon.png'
import * as leafletDraw from 'leaflet-draw'
import '../../node_modules/leaflet-draw/dist/leaflet.draw.css'

export const loader = async ({ params }) => {
  return defer({
    category: ideaCategory(`competition`),
    ideacategory2: ideaCategory2(`competition`),
    user: JSON.parse(sessionStorage.getItem('Response')),
  })
}
let map, tileLayer, addressMap, marker
let layerOnMap = []
let shapeLayerGroup

export default function Ardabil({ title }) {
  Title(title)
  const [loaderData, setLoaderData] = useState(useLoaderData())
  const [data, setData] = useState()
  const [error, setError] = useState()
  const [educationlevel, setEducationlevel] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [showPopup, setShowPopup] = useState(false)
  const [layers, setLayers] = useState()
  let [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const errors = useActionData()
  const params = useParams()

  let mapAddressRef = useRef()

  useEffect(() => {
    document.querySelector('header span').innerText = title

    getIdeaEdit(params.id).then((res) => {
      setData(res)
    })

    getEducationlevel().then(res =>{
      setEducationlevel(res)
    })
  }, [])

  return (
    <section className={styles.section}>
      <div className={`__frame`} data-width={`large`}>
        <div className={styles.formContainer} style={{ border: '2px solid #333' }}>
          {errors && <Navigate to="../list" />}

          {data && data.length > 0 && (
            <>
              <Suspense fallback={<LoadingSpinner />}>
                <Await resolve={loaderData.user} errorElement={<p>⚠️</p>}>
                  {(userData) => {
                    console.log(data)
                    return (
                      <div className={styles.form}>
                        <Form className="form" method="post" action={`/competition/edit/${params.id}`}>
                          <div className={styles.formGroup}>
                            <label>دسته بندی</label>

                            <Suspense fallback={<LoadingSpinner />}>
                              <Await resolve={loaderData.category} errorElement={<p>⚠️Could not load</p>}>
                                {(dataCat) => (
                                  <select name="ideacategory_id" defaultValue={dataCat.find((item) => item.id === data[0].ideacategory_id).id}>
                                    {dataCat.map((item, i) => {
                                      return (
                                        <option key={i} value={item.id}>
                                          {++i}) {item.name}
                                        </option>
                                      )
                                    })}
                                  </select>
                                )}
                              </Await>
                            </Suspense>
                          </div>

                          <div className={styles.formGroup}>
                            <label>زیرگروه دسته بندی</label>

                            <Suspense fallback={<LoadingSpinner />}>
                              <Await resolve={loaderData.ideacategory2} errorElement={<p>⚠️Could not load</p>}>
                                {(dataCat) => (
                                  <select name="ideacategory2_id" defaultValue={dataCat.find((item) => item.id === data[0].ideacategory2_id)?.id}>
                                    <option value="">انتخاب کنید</option>
                                    {dataCat.filter(item => item.ideacategory_id ==data[0].ideacategory_id).map((item, i) => {
                                      return (
                                        <option key={i} value={item.id}>
                                          {++i}) {item.name}
                                        </option>
                                      )
                                    })}
                                  </select>
                                )}
                              </Await>
                            </Suspense>
                          </div>

                          <div className={styles.formGroup}>
                            <label>
                              تحصیلات <span style={{ color: '#ff0000' }}>*</span>
                            </label>
                            <select name="education" required defaultValue={data[0].education}>
                                  <option value="">انتخاب کنید</option>
                                  {educationlevel && educationlevel.map((item, i) => {
                                    return (
                                      <option key={i} value={item.name}>
                                        {++i}) {item.name}
                                      </option>
                                    )
                                  })}
                                </select>
                          </div>

                          <div className={styles.formGroup}>
                            <label>
                              تلفن ثابت <span style={{ color: '#ff0000' }}>*</span>
                            </label>
                            <input type={'number'} name="tel" placeholder="" required defaultValue={data[0].tel} maxLength={12} />
                          </div>

                          {/* <div className={styles.formGroup}>
                            <label>
                              تلفن همراه <span style={{ color: '#ff0000' }}>*</span>
                            </label>
                            <input type={'number'} name="tel_ergent" placeholder="" required defaultValue={data[0].tel_ergent} maxLength={12} />
                          </div> */}

                          <div className={styles.formGroup}>
                            <label>
                              عنوان  <span style={{ color: '#ff0000' }}>*</span>
                            </label>
                            <input type={'text'} name="title" placeholder="" required defaultValue={data[0].title} />
                          </div>

                          <div className={styles.formGroup}>
                            <label>
                              توضیحات <span style={{ color: '#ff0000' }}>*</span>
                            </label>
                            <textarea type={'text'} name="description" placeholder="" required style={{ background: '#fff' }} defaultValue={data[0].description} />
                          </div>

                          <div className={styles.formGroup}>
                            <center>
                              <button
                                type="submit"
                                style={{
                                  padding: '1rem',
                                  background: 'var(--primary-color)',
                                  color: 'var(--white)',
                                }}
                                className={styles.submitButton}
                              >
                                بروزرسانی 
                              </button>
                            </center>
                          </div>
                        </Form>
                      </div>
                    )
                  }}
                </Await>
              </Suspense>
            </>
          )}
        </div>
      </div>
    </section>
  )
}

export const action = async ({ request, params }) => {
  console.clear()
  const formData = await request.formData()

  const post = {
    ideacategory_id: formData.get('ideacategory_id'),
    ideacategory2_id: formData.get('ideacategory2_id'),
    education: formData.get('education'),
    tel: formData.get('tel'),
    tel_ergent: formData.get('tel_ergent'),
    title: formData.get('title'),
    description: formData.get('description'),
  }

  try {
    const res = await ideaUpdate(post, params.id)
    console.log(res)
    if (res) {
      alert('درخواست با موفقیت بروزرسانی گردید')
      return true
    }
  } catch (error) {
    console.error(error)
  }

  return null
}
